import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubscribeBlock from './SubscribeBlock';
import './CustomiseTrip.css';

const steps = [
  {
    title: 'Опишите поездку',
    text: 'Расскажите о направлении, датах, бюджете и пожеланиях — мы учтём всё при подборе.',
  },
  {
    title: 'Получите предложение',
    text: 'Менеджер подготовит маршрут с отелями, перелётами и дополнительными услугами.',
  },
  {
    title: 'Забронируйте',
    text: 'Подтверждайте поездку только когда вас полностью устраивает предложенный план.',
  },
];

function CustomiseTrip() {
  const navigate = useNavigate();

  return (
    <>
      <section className="customise-trip-section page-section">
        <div className="page-container">
          <h2 className="section-title">Как мы работаем</h2>
          <p className="section-subtitle">
            Три простых шага от заявки до готового тура.
          </p>

          <div className="steps-grid">
            {steps.map((step, index) => (
              <article key={step.title} className="step-card">
                <span className="step-number">{index + 1}</span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </article>
            ))}
          </div>

          <div className="customise-cta">
            <button className="btn-primary" type="button" onClick={() => navigate('/book')}>
              Оставить заявку
            </button>
            <p className="cta-note">Бесплатно · без обязательств</p>
          </div>
        </div>
      </section>

      <SubscribeBlock />
    </>
  );
}

export default CustomiseTrip;
